import React from "react";
import Modal from "react-modal";
import Cookies from "js-cookie";
import _ from "lodash";
import Loader from "./Loader";
import Sorting from "./Sorting";
import "../css/SystemIntegratorAdd.css";
import RadioMaterialUI from "./RadioMaterialUI";
import SnackBar from "./SnackBar";
import Radio from "@mui/material/Radio";

//assign okas box modal page
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // minHeight: '10%',
    // maxHeight: '70%',
    height: "620px",
    overflow: "auto",
    marginLeft: "260px",
    padding: "40px 90px 40px 90px",
    marginTop: "3%",
    background: "#EFF3F6",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const customStylesSuccess = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "70%",
    overflow: "auto",
    padding: "2%",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

export default class AssignOkasBoxModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: "animated animated-duration-custom slideInDown",
      modalStateAftereOpenSuccess:
        "animated animated-duration-custom slideInDown",
      modalIsOpenSuccess: false,
      siData: [],
      selectedSI: "",
      loader: true,
      snackbarActive: false,
      snackbarMessage: "",
      sortingStatus: {
        sortingName: "",
        defaultDown: true,
      },
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModalSuccess() {
    this.setState(
      {
        modalStateAftereOpenSuccess:
          "animated animated-duration-custom slideOutUp",
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpen: false,
              modalIsOpenSuccess: false,
              siData: [],
              selectedSI: "",
            },
            () => this.props.successMessage("success"),
          );
        }, 500);
      },
    );
  }
  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState(
      {
        modalStateAftereOpen: "animated animated-duration-custom slideOutUp",
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpen: false,
            },
            () => {
              this.props.successMessage("success");
            },
          );
        }, 500);
      },
    );
  }

  componentDidMount() {
    this.fecthAllSI();
  }

  fecthAllSI = () => {
    var tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "X-CSRFToken": localStorage.getItem("csrftoken"),
      Authorization: tokenStored,
    };
    fetch("/cloud/distributors/", {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (response.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("csrftoken");
          localStorage.removeItem("auth");
          // const history = createHistory({ forceRefresh: true })
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          siData: data.data,
          actualData: data.data,
          loader: false,
        });
        // console.log(this.state.siData)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  assignBoxCheckHandler = (selectedSI) => {
    this.setState({ selectedSI });
  };

  restoreData = (data) => {
    this.setState({
      siData: data.data,
    });
  };

  sortingFunc = (type, searchValue) => {
    if (type !== "search") {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState(
          {
            sortingStatus: {
              sortingName: type,
              defaultDown: !this.state.sortingStatus.defaultDown,
            },
          },
          () => {
            if (
              this.state.sortingStatus.sortingName === type &&
              this.state.sortingStatus.defaultDown
            ) {
              Sorting(this.restoreData, type, this.state.actualData);
            } else if (
              this.state.sortingStatus.sortingName === type &&
              !this.state.sortingStatus.defaultDown
            ) {
              Sorting(this.restoreData, "reverse", this.state.siData);
            }
          },
        );
      } else {
        this.setState(
          {
            sortingStatus: {
              sortingName: type,
              defaultDown: true,
            },
          },
          () => {
            if (
              this.state.sortingStatus.sortingName === type &&
              this.state.sortingStatus.defaultDown
            ) {
              Sorting(this.restoreData, type, this.state.actualData);
            } else if (
              this.state.sortingStatus.sortingName === type &&
              !this.state.sortingStatus.defaultDown
            ) {
              Sorting(this.restoreData, "reverse", this.state.siData);
            }
          },
        );
      }
    } else if (type === "search") {
      type = "search";
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = "reverse";
      Sorting(this.restoreData, type, this.state.actualData);
    }
  };

  fetchIconType = (e) => {
    if (
      e === this.state.sortingStatus.sortingName &&
      this.state.sortingStatus.defaultDown
    ) {
      return "fas fa-chevron-down pointer ml-2 float-right";
    } else if (
      e === this.state.sortingStatus.sortingName &&
      !this.state.sortingStatus.defaultDown
    ) {
      return "fas fa-chevron-up pointer ml-2 float-right";
    } else {
      return "fas fa-chevron-down pointer ml-2 float-right icon-inactive";
    }
  };

  renderAllSI = () => {
    if (this.state.siData !== null) {
      let someData = this.state.siData.map((siElement, index) => {
        return (
          <tr key={index}>
            <th
              scope="col"
              style={{
                width: "10%",
                verticalAlign: "middle",
                cursor: "default",
              }}
            >
              <RadioMaterialUI
                changeHandler={this.assignBoxCheckHandler.bind(
                  this,
                  siElement.si_id,
                )}
                checkedStatus={
                  this.state.selectedSI === siElement.si_id ? true : false
                }
              />
            </th>
            <td
              scope="col"
              style={{
                width: "20%",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
            >
              {siElement.si_name}
            </td>
            <td
              scope="col"
              style={{
                width: "20%",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
            >
              {siElement.si_address}
            </td>
            <td
              scope="col"
              style={{
                width: "10%",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
            >
              {siElement.si_area}
            </td>
            <td
              scope="col"
              style={{
                width: "10%",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
            >
              {siElement.si_email}
            </td>
            <td
              scope="col"
              style={{
                width: "20%",
                verticalAlign: "middle",
                fontSize: "12px",
              }}
            >
              {" "}
              {siElement.si_mobile}
            </td>
          </tr>
        );
      });
      return someData;
    } else {
      return null;
    }
  };

  assignBox = (e) => {
    // e.preventDefault();
    var tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "X-CSRFToken": localStorage.getItem("csrftoken"),
      Authorization: tokenStored,
    };

    fetch("/cloud/assign_boxes/", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: this.state.selectedSI,
        okasBox_id: this.props.assigningBoxes,
      }),
    })
      .then((response) => {
        if (response.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("csrftoken");
          localStorage.removeItem("auth");
          // const history = createHistory({ forceRefresh: true })
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (data.message === "Success") {
          this.setState({
            modalIsOpenSuccess: true,
            modalIsOpen: false,
            loader: false,
          });
        } else {
          this.setState({
            snackbarActive: true,
            snackbarMessage: "Something went wrong",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  assignAnotherBox = (e) => {
    // e.preventDefault();
    var tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "X-CSRFToken": localStorage.getItem("csrftoken"),
      Authorization: tokenStored,
    };

    fetch("/cloud/assign_boxes/", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: this.state.selectedSI,
        okasBox_id: this.props.assigningBoxes,
      }),
    })
      .then((response) => {
        if (response.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("csrftoken");
          localStorage.removeItem("auth");
          // const history = createHistory({ forceRefresh: true })
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (data.message === "Success") {
          this.setState(
            {
              modalStateAftereOpen:
                "animated animated-duration-custom slideOutUp",
              loader: false,
            },
            () => {
              setTimeout(() => {
                this.setState(
                  {
                    modalIsOpen: false,
                  },
                  () => this.props.successMessage("addAnother"),
                );
              }, 500);
            },
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <React.Fragment>
        <SnackBar
          open={this.state.snackbarActive}
          handleSnackbarClose={() => {
            this.setState({
              snackbarActive: false,
            });
          }}
          message={this.state.snackbarMessage}
        />
        {this.state.loader ? <Loader /> : null}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-2">
            ASSIGN DISTRIBUTOR TO THE SELECTED INVENTORY
          </h3>
          <div>
            <table
              className="table"
              style={{ marginTop: "20px", width: "100%" }}
            >
              <thead
                className="tableHeaderColor"
                style={{ borderRadius: "10px 10px 0px 0px" }}
              >
                <th scope="col" style={{ width: "10%" }}></th>
                <th scope="col" style={{ width: "20%", fontSize: "12px" }}>
                  Distributor Name
                </th>
                <th scope="col" style={{ width: "20%", fontSize: "12px" }}>
                  Address
                </th>
                <th scope="col" style={{ width: "10%", fontSize: "12px" }}>
                  Area
                </th>
                <th style={{ width: "10%", fontSize: "12px" }}>EMAIL</th>
                <th scope="col" style={{ width: "20%", fontSize: "12px" }}>
                  {" "}
                  Phone Number
                </th>
              </thead>
              <tbody style={{ height: "360px", overflowY: "auto" }}>
                {this.renderAllSI()}
              </tbody>
            </table>
          </div>
          <div className="float-right" style={{ marginTOp: "70px" }}>
            <div
              className="btn btn-new-grey"
              style={{ marginRight: "15px" }}
              onClick={(e) => {
                this.setState(
                  {
                    modalIsOpen: false,
                    modalIsOpenSuccess: false,
                    siData: [],
                    selectedSI: "",
                  },
                  () => this.props.successMessage("success"),
                );
              }}
            >
              Close
            </div>
            {/* <div className="btn btn-new-orange" style={{ marginRight: '15px' }}
              onClick={(e) => {
                if (this.state.selectedSI === '') {
                  this.setState({
                    snackbarActive: true,
                    snackbarMessage: 'Please select Distributor.'
                  })
                } else {
                  this.setState({
                    loader: true
                  }, () => this.assignAnotherBox())
                }
              }
              } >
              Assign Another</div> */}
            <div
              className="btn btn-new-green"
              onClick={(e) => {
                if (this.state.selectedSI === "") {
                  this.setState({
                    snackbarActive: true,
                    snackbarMessage: "Please select Distributor.",
                  });
                } else {
                  this.setState(
                    {
                      loader: true,
                    },
                    () => this.assignBox(),
                  );
                }
              }}
            >
              Assign
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div
              className="float-right cross-times"
              onClick={this.closeModalSuccess}
            >
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">
              {this.props.assigningBoxes.length > 1
                ? "Boxes assigned to Distributor successfully."
                : "Box assigned to Distributor successfully."}
            </h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div
              className="btn btn-new-grey"
              onClick={(e) => {
                this.setState(
                  {
                    modalIsOpen: false,
                    modalIsOpenSuccess: false,
                    siData: [],
                    selectedSI: "",
                  },
                  () => this.props.successMessage("success"),
                );
              }}
            >
              Close
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
